import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosSharedViajeComponent {
  colaborador
  data
  desplegable
  desplegar = false
  idColaborador
  idProyecto
  onChange
  soloLectura

  change (data) {
    this.onChange({$event: {detail: data}})
  }
}

module.component('viaticosSharedViaje', {
  controller: ViaticosSharedViajeComponent,
  template,
  bindings: {
    colaborador: '<',
    idProyecto: '<',
    idColaborador: '<',
    data: '<',
    desplegable: '<',
    soloLectura: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/viaje/component.js